import { render, staticRenderFns } from "./InventoryAdvancePaymentActivityDialog.vue?vue&type=template&id=2406cd1c&"
import script from "./InventoryAdvancePaymentActivityDialog.vue?vue&type=script&lang=ts&"
export * from "./InventoryAdvancePaymentActivityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports